import { SettingsStages } from '../../models/Settings';
import { createSlice } from '../wrappers';

interface ISettingsState {
	activeSettingsState: SettingsStages;
}

const initialState: ISettingsState = {
	activeSettingsState: SettingsStages.MAIN,
};

const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		setActiveSettingsState: (state, action) => {
			state.activeSettingsState = action.payload;
		},
	},
});

export const { setActiveSettingsState } = settingsSlice.actions;

export default settingsSlice.reducer;
